module.exports = __webpack_public_path__ + "static/media/3.4f801c38.png";